import { render, staticRenderFns } from "./postal-code-input.vue?vue&type=template&id=2c9e3454&"
import script from "./postal-code-input.ts?vue&type=script&lang=ts&"
export * from "./postal-code-input.ts?vue&type=script&lang=ts&"
import style0 from "./postal-code-input.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports